import React from 'react';
// import './Spinner.css'; // Create a CSS file for spinner styles

const Spinner: React.FC = () => {
  return (
    <div className="spinner spinner-primary spinner-lg"></div>
  );
};

export default Spinner;